import React from 'react';
import { connect } from 'react-redux';
import RedDownArrowIcon from '../../../icons/RedDownArrowIcon';
import GreenUpArrowIcon from '../../../icons/GreenUpArrowIcon';
import { arrayIsNotEmpty, isDefined } from '../../../utils';

class JibeSummery extends React.Component {
    constructor() {
        super();
        this.state = {
        };
    }

    render() {
        const
            {
                surveySummery,
                jibeSessions
            } = this.props;
        if (!arrayIsNotEmpty(surveySummery))
            return <div></div>
        const max = surveySummery[0].number;

        const summery = surveySummery.map((res, index) => {
            let arrow;
            if (isDefined(res.changes)) {
                if (res.changes > 0) {
                    arrow = <GreenUpArrowIcon />;
                }
                else if (res.changes < 0) {
                    arrow = <RedDownArrowIcon />
                }
            }

            let change;
            if (isDefined(res.changes)) {
                if (res.changes === 0) {
                    change = 'No Change'
                }
                else {
                    change = Math.abs(res.changes) + '%';
                }
            }

            const backgroundColor = `repeating-linear-gradient(45deg,  ${res.barColor},  ${res.barColor} 8px , rgb(237, 239, 248),rgb(237, 239, 248) 10px)`
            const widthPercentage = `${(res.number * 70) / max}%`
            return (<div key={index} style={{ marginBottom: '10px' }} className="flex-container-start">
                <div className="JibeSummery-text flex-container-end" style={{ fontSize: '16px' }}>{res.text}</div>
                <div className="SurveyCountSummery-bar"
                    style={{ background: backgroundColor, width: widthPercentage }}></div>
                <div style={{ marginRight: '10px' }} >{res.number}%</div>
                {isDefined(res.rate) && <div style={{ color: 'gray', marginRight: '5px' }}>{res.rate}</div>}
                {arrow}
                {isDefined(change) && <div style={{ color: 'gray' }}>{change}</div>}
                {/*                {isDefined(change) && <div style={{ color: 'gray' }} className="chart_stork flex-container-center">1 week</div>}*/}
            </div>)
        });

        return <div className="system-dashboard-jibe-border SurveyCountSummery-main"
            style={{ backgroundImage: `url(${`../../../../../Assets/Images/V3Design/profileAgentNoAvatar.png`})` }}>
            <div className="flex-container" style={{ minHeight: '38px', borderBottom: '1px solid #E6F7F8', }}>
                <div className="title-primary-400-24-28">
                    Jibe Summary
                </div>
            </div>
            <div className="flex-container-start-align-start" style={{ marginTop: '15px' }}>
                <div style={{ width: '70%' }}>
                    {summery}
                </div>
                <div className="flex-container-start" style={{ marginRight: '75px' }} >
                    <div>
                        <div className="flex-container-start" style={{ flexDirection: 'column' }}>
                            <div className="SurveyCountSummery-time">{jibeSessions}</div>
                            <div style={{ justifyContent: 'center', fontSize: '16px' }}>
                                Jibe Sessions Last 30 days
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
}

const select = state => ({});

export default connect(select)(JibeSummery);